import { OfferOrder } from 'src/models/offer-orders.model';
import { Order } from 'src/models/orders.models';
import { Transfer } from 'src/models/transfers.models';

export const isOrder = (value: Order | OfferOrder | Transfer): value is Order => Boolean((value as any).symbol);

export const isTransfer = (value: Order | OfferOrder | Transfer): value is Transfer =>
  Boolean((value as any).mechanism);
